import { render, staticRenderFns } from "./typeEdit.vue?vue&type=template&id=247a8ad4&"
import script from "./typeEdit.vue?vue&type=script&lang=js&"
export * from "./typeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports